import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./index.scss";

function createRootElement(id: string) {
  const rootContainer = document.createElement("div");
  rootContainer.setAttribute("id", id);
  return rootContainer;
}

function addRootElement(rootElem: Node) {
  const last: any = document.body.lastElementChild?.nextElementSibling;
  document.body.insertBefore(rootElem, last);
}

const id = "nafutel-loading";

function NafutelRootLoadingComponent() {
  const rootElemRef = useRef<any>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`);
    const parentElem = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElem);
    }
    parentElem.appendChild(rootElemRef.current);
    return () => {
      rootElemRef.current.remove();
      if (!parentElem.childElementCount) {
        parentElem.remove();
      }
    };
  }, []);

  function getRootElem() {
    if (!rootElemRef.current) {
      rootElemRef.current = document.createElement("div");
    }
    return rootElemRef.current;
  }

  const childNode = (): React.ReactNode => {
    return (
      <div className="nafutel-loading">
        <div className="wrap-loading">
          <div className="child">
            <div className="lds-spinner">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
          <div className="wrap-text">
            <div className="text-1">{t("common.loading")}</div>
          </div>
        </div>
        <div className="background"></div>
      </div>
    );
  };

  return createPortal(childNode(), getRootElem());
}

export default NafutelRootLoadingComponent;
